import { render, staticRenderFns } from "./weeklyOT.vue?vue&type=template&id=6c095a97&scoped=true&"
import script from "./weeklyOT.vue?vue&type=script&lang=js&"
export * from "./weeklyOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c095a97",
  null
  
)

export default component.exports